module.exports = __webpack_public_path__ + "static/img/Bosun_findworka.8b1e52c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Bosun_findworka.jpg
// module id = GAAZ
// module chunks = 1